import React, { useEffect, useState } from 'react';
import { Button, Form, InputGroup, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import validator from 'validator';
import { putRequest } from '../../../helpers/apiHandler';
import CustomAlert from '../../../components/CustomAlert';
import config from '../../../config/Constant';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const UserSecurity = ({ access_token }) => {
  const [loadingSave, setLoadingSave] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [currentPasswordError, setCurrentPasswordError] = useState({
    error: false,
    message: '',
  });
  const [newPasswordError, setNewPasswordError] = useState({
    error: false,
    message: '',
  });
  const [confirmPasswordError, setConfirmPasswordError] = useState({
    error: false,
    message: '',
  });
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const updatePassword = (evt) => {
    evt.preventDefault();
    const form = evt.currentTarget;

    if (form.checkValidity() === false) {
      evt.stopPropagation();
    }

    if (validator.isEmpty(currentPassword)) {
      setCurrentPasswordError({
        error: true,
        message: 'Please enter your password.',
      });
      return;
    }

    if (!validator.isLength(currentPassword, { min: 8, max: undefined })) {
      setCurrentPasswordError({
        error: true,
        message: 'The password must be at least 8 characters long.',
      });
      return;
    }

    if (validator.isEmpty(newPassword)) {
      setNewPasswordError({
        error: true,
        message: 'Please enter your password.',
      });
      return;
    }

    if (
      !validator.matches(
        newPassword,
        /(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!=]).*$/g
      )
    ) {
      setNewPasswordError({
        error: true,
        message:
          'Please choose a strong password that includes at least 1 lowercase and uppercase letter, a number, as well as a special character (!@#$%^&*)',
      });
      return;
    }

    if (!validator.isLength(newPassword, { min: 8, max: undefined })) {
      setNewPasswordError({
        error: true,
        message: 'The password must be at least 8 characters long.',
      });
      return;
    }

    if (validator.isEmpty(confirmPassword)) {
      setConfirmPasswordError({
        error: true,
        message: 'Please enter your password.',
      });
      return;
    }

    if (
      !validator.matches(
        confirmPassword,
        /(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!=]).*$/g
      )
    ) {
      setConfirmPasswordError({
        error: true,
        message:
          'Please choose a strong password that includes at least 1 lowercase and uppercase letter, a number, as well as a special character (!@#$%^&*)',
      });
      return;
    }

    const min_pwd_length = white_label_perkeso ? 12 : 8;
    if (!validator.isLength(confirmPassword, { min: min_pwd_length, max: undefined })) {
      setConfirmPasswordError({
        error: true,
        message: `The password must be at least  ${min_pwd_length} characters long.`,
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      setNewPasswordError({ error: true, message: "Password doesn't match." });
      setConfirmPasswordError({ error: true, message: "Password doesn't match." });
    }

    setLoadingSave(true);
    const data = {
      current_password: currentPassword,
      password: newPassword,
      confirm_password: confirmPassword,
    };
    putRequest('/auth/change-password', data, access_token.token, (res) => {
      if (!res.error) {
        setAlertState({
          message: 'Your changes have successfully been saved',
          show: true,
          variant: 'success',
        });
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setLoadingSave(false);
      } else {
        setAlertState({
          message: res.message,
          show: true,
          variant: 'danger',
        });
        setLoadingSave(false);
      }
    });
  };

  const handleShowCurrentPassword = () => {
    setShowCurrentPassword(!showCurrentPassword);
  };

  const handleShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  const handleShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleUserInput = (evt) => {
    const { name, value } = evt.target;
    switch (name) {
      case 'currentPassword':
        setCurrentPassword(value);
        setCurrentPasswordError({ error: false, message: '' });
        break;
      case 'newPassword':
        setNewPassword(value);
        setNewPasswordError({ error: false, message: '' });
        break;
      case 'confirmPassword':
        setConfirmPassword(value);
        setConfirmPasswordError({ error: false, message: '' });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <div className="UserSecurity">
      <div className="page-heading">
        <div className="container-left">
          <div className="page-title">Security</div>
        </div>
        <p>Change website password</p>
      </div>
      <div className="page-content">
        <Form noValidate onSubmit={updatePassword} style={{ width: '50%' }}>
          <CustomAlert
            message={alertState.message}
            show={alertState.show}
            variant={alertState.variant}
            closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
          />
          <Form.Group>
            <Form.Label>Current Password</Form.Label>
            <InputGroup className="input-group-password" hasValidation>
              <Form.Control
                required
                type={showCurrentPassword ? 'text' : 'password'}
                placeholder="Your Password"
                name="currentPassword"
                value={currentPassword}
                onChange={handleUserInput}
                isInvalid={currentPasswordError.error}
              />
              <InputGroup.Append>
                <InputGroup.Text onClick={handleShowCurrentPassword}>
                  <img
                    src={require(`../../../assets/AlertIcons/${showCurrentPassword ? 'icon-eye.svg' : 'icon-eye-close.svg'
                      }`)}
                    width={24}
                    height={24}
                    alt="..."
                  />
                </InputGroup.Text>
              </InputGroup.Append>
              <Form.Control.Feedback type="invalid">
                {currentPasswordError.message}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
          <Form.Group>
            <Form.Label>New Password</Form.Label>
            <InputGroup className="input-group-password" hasValidation>
              <Form.Control
                required
                type={showNewPassword ? 'text' : 'password'}
                placeholder="Your Password"
                name="newPassword"
                value={newPassword}
                onChange={handleUserInput}
                isInvalid={newPasswordError.error}
              />
              <InputGroup.Append>
                <InputGroup.Text onClick={handleShowNewPassword}>
                  <img
                    src={require(`../../../assets/AlertIcons/${showNewPassword ? 'icon-eye.svg' : 'icon-eye-close.svg'
                      }`)}
                    width={24}
                    height={24}
                    alt="..."
                  />
                </InputGroup.Text>
              </InputGroup.Append>
              <Form.Control.Feedback type="invalid">
                {newPasswordError.message}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
          <Form.Group>
            <Form.Label>Confirm Password</Form.Label>
            <InputGroup className="input-group-password" hasValidation>
              <Form.Control
                required
                type={showConfirmPassword ? 'text' : 'password'}
                placeholder="Your Password"
                name="confirmPassword"
                value={confirmPassword}
                onChange={handleUserInput}
                isInvalid={confirmPasswordError.error}
              />
              <InputGroup.Append>
                <InputGroup.Text onClick={handleShowConfirmPassword}>
                  <img
                    src={require(`../../../assets/AlertIcons/${showConfirmPassword ? 'icon-eye.svg' : 'icon-eye-close.svg'
                      }`)}
                    width={24}
                    height={24}
                    alt="..."
                  />
                </InputGroup.Text>
              </InputGroup.Append>
              <Form.Control.Feedback type="invalid">
                {confirmPasswordError.message}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
          <Form.Group>
            <Button
              type="submit"
              variant="primary"
              disabled={loadingSave}
              style={{ minWidth: 160 }}
            >
              {loadingSave && <Spinner animation="border" size="sm" className="mr-2" />}
              Save
            </Button>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { access_token, user } = state.auth;

  return {
    access_token,
    user,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UserSecurity);
